<template>
  <div>
    <cs-form
      label-width="90px"
      form-width="100%"
      :form="form"
      :formData="searchData"
      :form-col="searchFormCol"
      :inline="true"
      class="header-search-box"
    >
      <template slot="updateTimeArr">
        <el-date-picker
          @change="formChange"
          v-model="updateTimeArr"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>
      <template slot="search">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="exportList">导出Excel</el-button>
      </template>
    </cs-form>
    <div class="padding-b-20">
      <el-button type="primary" @click="goAddGroup">
        <i class="icon-tianjia" style="font-size: 12px;"></i>
        添加节目集
      </el-button>
      <el-button @click="handleSubmitPass()">批量送审</el-button>
      <el-button @click="handleSubmitDel()">批量删除</el-button>
    </div>
    <cs-table
      ref="multipleTable"
      :tableCols="tableCols"
      class="no-shadow-table"
      :tableData="tableData"
      :paginationOption="paginationOption"
      @row-dblclick="dbClick"
      :show-header="false"
      :page-size="20"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler"
      @selection-change="selectionChange"
    >
      <template slot-scope="scope" slot="imgUrl">
        <program-list type="21" :data="scope.row" @goEditPage="goEditPage(scope.row)">
          <tags-list  :data="scope.row.tagsList" slot="title-slot"/>
          <strong class="underline" slot="row-slot" @click="goDetailInfo(scope.row)">更多数据<i class="el-icon-d-arrow-right"></i></strong>
        </program-list>
      </template>
    </cs-table>
    <insideDialog ref="insideDataDialog"
    :goEdit="true"
    :imgUrl="imgUrl"
    :groupIn="groupIn"
    @goEditPage="goEditPage"
    @goRelease="goRelease"
    :insideData="insideData"/>
    <detailDialog ref="detailDataDialog" :detailData="detailData"/>
    <releaseStatusDialog ref="releaseStatusDataDialog" :releaseStatusData="releaseData"></releaseStatusDialog>
  </div>
</template>
<script>
import { addData } from '@/resource/api/data.js'
import { programSets, getProgramGroupCount, checkReason, sendPrograms, programSetsDel, batchAuditProgramSets, pushFlag } from '@/resource/api/program-group-management'
import insideDialog from '@/views/common/dialog/program-group-detail.vue'
import detailDialog from '@/views/common/dialog/data-detail.vue'
import ProgramList from '@/components/ProgramList'
import TagsList from '@/components/TagsList'
import releaseStatusDialog from '@/views/common/dialog/releaseStatusDialog.vue'
export default {
  components: {
    insideDialog,
    detailDialog,
    ProgramList,
    TagsList,
    releaseStatusDialog
  },
  data () {
    return {
      imgUrl: '',
      tagsList: [],
      auditOptions: [],
      updateTimeArr: [],
      passStyle: '',
      form: {
        name: '',
        timeFlag: 'updateTime',
        startTime: '',
        endTime: '',
        auditState: '',
        operator: '',
        dataFlag: 0,
        limit: 20,
        offset: 1
      },
      createTimeArr: [],
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableCols: [
        { type: 'selection', width: 55 },
        { prop: 'imgUrl', label: '封面图', type: 'slot', align: 'left' },
        {
          prop: 'control',
          type: 'spbtn',
          label: '操作',
          width: 270,
          groups: [
            {
              type: '',
              isShow: () => true,
              title: '详情',
              clickHandler: this.goInsideDetailInfo
            },
            {
              type: '',
              isShow: function (row) {
                if ((row.auditState == 'AUDIT_ING') || (row.auditState == 'RE_AUDIT_ING') || (row.auditState == 'UNIFORM_AUDIT_ING')) {
                  return false
                } else {
                  return true
                }
              },
              title: '管理',
              clickHandler: this.goManagementGroup
            },
            {
              type: '',
              isShow: function (row) {
                return row.auditState == 'AUDIT_NON'
              },
              title: '送审',
              clickHandler: this.auditItem
            },
            {
              type: '',
              isShow: function (row) {
                if ((row.auditState == 'AUDIT_NO_PASS') || (row.auditState == 'RE_AUDIT_NO_PASS')) {
                  return true
                } else {
                  return false
                }
              },
              title: '审核',
              clickHandler: this.unPassGoAudit
            },
            {
              type: '',
              isShow: function (row) {
                if ((row.auditState == 'AUDIT_NO_PASS') || (row.auditState == 'RE_AUDIT_NO_PASS') || (row.auditState == 'UNIFORM_AUDIT_NO_PASS')) {
                  return true
                } else {
                  return false
                }
              },
              title: '查看原因',
              clickHandler: this.viewReason
            }
          ]
        }
      ],
      tableData: [],
      multipleSelection: [],
      paginationOption: {},
      insideData: {},
      detailData: {},
      releaseData: {},
      groupIn: 'programs'
    }
  },
  computed: {
    searchData () {
      return [
        { prop: 'name', type: 'input', label: '标题：', placeholder: '请输入', clearable: true, labelWidth: '60px', col: [3, 3, 3] },
        {
          prop: 'updateTimeArr',
          label: '更新时间：',
          type: 'slot'
        },
        {
          prop: 'auditState',
          label: '审核状态：',
          type: 'select',
          filterable: true,
          options: this.auditOptions
        },
        { prop: 'search', type: 'slot', label: '', col: [3, 3, 3] }
      ]
    }
  },
  created () {
    this.pageInit()
  },
  methods: {
    // 初始化
    pageInit () {
      this.form.operator = this.$store.state.router.createBySuffix
      this.paginationOption['page-size'] = this.$store.state.pageLimit
      this.form.limit = this.$store.state.pageLimit
      this.getData(this.form)
      this.auditOptions = addData.auditOptions
    },
    // 加载数据
    getData (data) {
      const that = this
      programSets(data).then((res) => {
        if (res.code == 1) {
          that.tableData = res.results.map((item, index) => {
            var itemTagList = []
            if (item.sndCategory) {
              itemTagList.push(item.category, item.sndCategory)
            } else {
              itemTagList.push(item.category)
            }
            item.tagsList = itemTagList
            item.playCount = null
            item.browseCount = null
            getProgramGroupCount({ programIds: item.id }).then((res) => {
              if (res.code == 1) {
                if (res.result[0]) {
                  item.playCount = res.result[0].playCount
                  item.browseCount = res.result[0].browseCount
                }
              }
            })
            return item
          })
          this.paginationOption = {
            ...this.paginationOption,
            'current-page': this.form.offset,
            total: parseInt(res.total)
          }
        } else {
          that.$message({
            message: res.msg,
            type: 'error'
          })
          return false
        }
      })
    },
    // 查询
    search () {
      this.form = {
        ...this.form,
        offset: 1,
        limit: this.$store.state.pageLimit
      }
      this.currentPageHandler(1)
    },
    formChange (timeArr) {
      if (timeArr === null) {
        this.form.startTime = ''
        this.form.endTime = ''
      } else {
        this.form.startTime = timeArr[0]
        this.form.endTime = timeArr[1]
      }
    },
    // 导出
    exportList () {
      /* window.location.href = process.env.VUE_APP_BASE_API_MGR + `/programSets/exportList?name=${this.form.name}&startTime=${this.form.startTime}&endTime=${this.form.endTime}&timeFlag=${this.form.timeFlag}&auditState=${this.form.auditState}&operator=${this.form.operator}&limit=${this.form.limit}&offset=${this.form.offset}` */
      const data = {
        name: this.form.name,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        timeFlag: this.form.timeFlag,
        auditState: this.form.auditState,
        operator: this.form.operator,
        limit: this.form.limit,
        offset: this.form.offset
      }
      this.$axios({
        // 跨域设置---------------------start
        async: true,
        crossDomain: true,
        withCredentials: true,
        headers: {
          AJAX: true
        },
        // 跨域设置---------------------end
        method: 'GET',
        url: process.env.VUE_APP_BASE_API_MGR + '/programSets/exportList',
        params: data,
        responseType: 'blob',
        timeout: 1000 * 60 * 3
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })

        const fileName = 'Excel_' + this.$moment(new Date()).format('YYYYMMDDHHmmss') +
          '.xls'
        const linkNode = document.createElement('a')

        linkNode.download = fileName // a标签的download属性规定下载文件的名称
        linkNode.style.display = 'none'
        linkNode.href = URL.createObjectURL(blob) // 生成一个Blob URL
        document.body.appendChild(linkNode)
        linkNode.click() // 模拟在按钮上的一次鼠标单击

        URL.revokeObjectURL(linkNode.href) // 释放URL 对象
        document.body.removeChild(linkNode)
      }).catch(err => {
        if (err.response && err.response.status == 601) {
          this.$message({
            type: 'error',
            message: '暂无数据可导出'
          })
        } else {
          this.$message({
            type: 'error',
            message: '程序异常'
          })
        }
      })
    },
    // 送审
    auditItem (row) {
      const data = {
        id: row.id,
        operator: this.$store.state.router.updateBySuffix,
        auditState: 'AUDIT_ING'
      }
      sendPrograms(data).then((res) => {
        if (res && res.code == 1) {
          this.$message({
            message: '已入审核页面',
            type: 'success'
          })
          this.currentPageHandler(1)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    // 审核
    unPassGoAudit (row) {
      const data = {
        id: row.id,
        operator: this.$store.state.router.updateBySuffix
      }
      if (row.auditState == 'AUDIT_NO_PASS') {
        data.auditState = 'AUDIT_ING'
      } else if (row.auditState == 'RE_AUDIT_NO_PASS') {
        data.auditState = 'RE_AUDIT_ING'
      }

      sendPrograms(data).then((res) => {
        if (res && res.code == 1) {
          this.$message({
            message: '已成功提交审核',
            type: 'success'
          })
          this.currentPageHandler(1)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    // 批量送审
    handleSubmitPass () {
      const needAuditArr = []
      if (this.multipleSelection.length == 0) {
        this.$message('还没有选中内容')
      } else {
        this.multipleSelection.forEach(item => {
          // if (item.auditState == 'AUDIT_NON') { // 待初审
          const itemObj = {
            id: item.id,
            operator: this.$store.state.router.updateBySuffix,
            auditState: 'AUDIT_ING'
          }
          needAuditArr.push(itemObj)
          // }
        })
        // if (needAuditArr.length < 1) {
        //   this.$message('没有需要审核的内容')
        // } else {
        this.handleSubmitAudit(needAuditArr)
        // }
      }
    },

    // 批量审核
    handleSubmitAudit (needAuditArr) {
      batchAuditProgramSets(needAuditArr).then((res) => {
        if (res && res.code == 1) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.currentPageHandler(1)
        }
      })
    },
    // 批量删除
    handleSubmitDel (passState, arr) {
      let needDelArr = []
      if (this.multipleSelection.length == 0) {
        this.$message('还没有选中内容')
      } else if (this.multipleSelection.length > 0) {
        this.$confirm('确定永久删除吗?', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          needDelArr = this.multipleSelection.map(item => item.id)
          const data = {
            updateBy: this.$store.state.router.updateBySuffix,
            programSetIds: needDelArr
          }
          programSetsDel(data).then((res) => {
            if (res && res.code == 1) {
              this.$message({
                message: '批量删除成功',
                type: 'success'
              })
              this.currentPageHandler(1)
            } else if (res && res.code == 0) {
              this.$message.error(res.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 双击当前条目查看详情
    dbClick (row, column, event) {
      this.goInsideDetailInfo(row)
    },
    // 获取选中数据
    selectionChange (selection) {
      this.multipleSelection = selection
    },
    sizeChangeHandler (val) {
      this.form.limit = val
      this.form.offset = 1
      this.getData(this.form)
    },
    currentPageHandler (val) {
      this.form.offset = val
      this.getData(this.form)
    },
    // 去添加节目集
    goAddGroup () {
      this.$router.push({
        path: '/createGroup'
      })
    },
    // 点击标题进去编辑节目集
    goEditPage (row) {
      if (row.auditState == 'AUDIT_ING' || row.auditState == 'RE_AUDIT_ING' || row.auditState == 'RE_AUDIT_PASS') {
        this.$alert('内容审核中不可编辑', '提示', {
          confirmButtonText: '知道了'
        })
      } else {
        this.$router.push({
          path: '/editGroup',
          query: {
            programSetId: row.id
          }
        })
      }
    },
    // 管理添加节目集
    goManagementGroup (row) {
      this.$router.push({
        path: '/managementGroup',
        query: {
          dataParams: JSON.stringify({
            programSetId: row.id,
            category: row.category
          })
        }
      })
    },
    // 查看详情
    goInsideDetailInfo (row) {
      this.insideData = row
      console.log(this.insideData, 'this.insideData')
      this.imgUrl = row.posterH
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.insideDataDialog.open()
      })
    },
    // 查看详情-状态-发布状态详情
    goRelease () {
      const that = this
      const data = {
        id: that.insideData.id,
        companyId: this.$store.state.router.companyId
      }
      pushFlag(data).then((res) => {
        if (res.code == '1') {
          that.releaseData = res.results
          that.$nextTick(() => {
            that.$refs.releaseStatusDataDialog.open()
          })
        }
      })
    },
    goDetailInfo (row) {
      this.detailData = row
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.detailDataDialog.open()
      })
    },
    // 查看原因
    viewReason (row) {
      const data = {
        resourceId: row.id,
        type: 1
      }
      switch (row.auditState) {
        case 'AUDIT_NO_PASS':
          data.recordType = 1
          break
        case 'RE_AUDIT_NO_PASS':
          data.recordType = 3
          break
        case 'UNIFORM_AUDIT_NO_PASS':
          data.recordType = 2
          break
      }
      checkReason(data).then((res) => {
        if (res.code == 1) {
          this.$alert(res.result, '原因', {
            confirmButtonText: '知道了'
          })
        }
      })
    }
  }
}
</script>
